module.exports = __webpack_public_path__ + "static/media/DiamondSunset.34e1f1ea.svg";